const ACTION_TYPES = {
  ALL: "ALL",
  PAGINATE: "PAGINATE",
  SELECT: "SELECT",
  ADD: "ADD",
  UPDATE: "UPDATE",
  REMOVE: "REMOVE",
};

const reducers = (state, action) => {
  switch (action.type) {
    case ACTION_TYPES.ALL: {
      return {
        ...state,
        clients: action.data
      };
    }
    case ACTION_TYPES.PAGINATE: {
      return {
        ...state,
        rows: action.data.data,
        page: action.data.paginatorInfo.currentPage,
        perPage: action.data.paginatorInfo.perPage,
        total: action.data.paginatorInfo.total,
        currentPage: action.data.paginatorInfo.currentPage,
      };
    }
    case ACTION_TYPES.ADD: {
      return {
        ...state,
        rows: [...state.rows, action.data],
      };
    }
    case ACTION_TYPES.VIEW: {
      return {
        ...state,
        clients: action.data.client,
      };
    }
    case ACTION_TYPES.UPDATE: {
      return {
        ...state,
        clients:
          state?.clients?.length > 0
            ? state.clients.map((item) =>
                item.id === action.data.client.id ? action.data.client : item
              )
            : [],
        rows:
          state?.rows?.length > 0
            ? state.rows.map((item) =>
                item.id === action.data.client.id ? action.data.client : item
              )
            : [],
      };
    }
    case ACTION_TYPES.REMOVE: {
      return {
        ...state,
        rows: state?.rows?.filter(({ id }) => id !== action.id),
      };
    }
    default: {
      return state;
    }
  }
};

export { reducers, ACTION_TYPES };
